<template>
  <div class="container mt-2">
    <!-- Formulario de apertura de cuenta de ahorro -->
    <div
      class="box mt-4"
      style="
        max-width: 900px;
        margin: auto;
        background-color: rgb(243, 243, 243);
        color: #161616;
      "
      v-if="!error && request"
    >
      <!-- Encabezado del formulario -->
      <div class="columns is-vcentered mb-4">
        <div class="column">
          <img
            v-if="
              request &&
              request.entity &&
              request.entity.settings &&
              request.entity.settings.logo
            "
            :src="drive_static_file_url(request.entity.settings.logo)"
            alt="MultiMoney Logo"
            style="height: 60px"
          />
          <!-- <div class="has-text-weight-bold" style="font-size: 1.2rem">
            <span class="icon mr-2">
              <i class="fa fa-asterisk"></i>
            </span>
            multi<br />money
          </div> -->
        </div>
        <div class="column has-text-centered">
          <div class="title is-4 has-text-weight-bold">
            {{ $t("banco multimoney s a") }}
          </div>
          <!-- <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">{{ $t("form number") }}:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <input
                  class="input is-small"
                  v-model="meta.form_number"
                  style="width: 100px"
                />
              </div>
            </div>
          </div> -->
        </div>
        <div class="column">
          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">{{ $t("date") }}:</label>
            </div>
            <div class="field-body">
              <span class="is-size-6">
                {{ format_date(new Date()) }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Título del formulario -->
      <div class="has-text-centered mb-4">
        <h4 class="title is-4 mb-2">
          {{ $t("opening form") }}
        </h4>
        <h5 class="title is-5 mb-2">
          {{ request.product?.name }}
        </h5>
        <h5 class="subtitle is-5">
          {{ $t("individual person") }}
        </h5>
      </div>

      <!-- Tipo de actuación del titular -->
      <div class="section-header">
        <p class="has-text-weight-bold">
          {{ $t("account holder acting type") }}
        </p>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("the holder acts on their own behalf") }}:</label
            >
            <div class="control">
              <label class="radio mr-3">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_acts_own_behalf_yes"
                  name="chk_acts_own_behalf"
                  value="yes"
                  v-model="meta.acting_type.acts_own_behalf"
                  disabled
                />
                <label for="chk_acts_own_behalf_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_acts_own_behalf_no"
                  name="chk_acts_own_behalf"
                  value="no"
                  v-model="meta.acting_type.acts_own_behalf"
                  disabled
                />
                <label for="chk_acts_own_behalf_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 1. Datos de Identidad -->
      <div class="section-header">
        <p class="has-text-weight-bold">1. {{ $t("identity data") }}</p>
      </div>

      <div class="columns is-multiline mb-4">
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("first name") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.first_name"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("second name") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.second_name"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("first surname") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.first_surname"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("second surname") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.second_surname"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("married surname if applies") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.married_surname"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label"
              >{{ $t("cui dpi") }} (13 {{ $t("digits") }}):</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.cui"
                maxlength="13"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("nit") }}:</label>
            <div class="control">
              <input class="input is-borderless" v-model="meta.identity.nit" />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("birth date") }} (dd/mm/aaaa):</label>
            <div class="control">
              <input
                class="input is-borderless"
                type="date"
                v-model="meta.identity.birth_date"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{ $t("nationality") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.nationality"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("do you have other nationality") }}?</label
            >
            <div class="control">
              <label class="radio mr-3">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_other_nationality_yes"
                  name="chk_other_nationality"
                  value="yes"
                  v-model="meta.identity.has_other_nationality"
                />
                <label for="chk_other_nationality_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_other_nationality_no"
                  name="chk_other_nationality"
                  value="no"
                  v-model="meta.identity.has_other_nationality"
                />
                <label for="chk_other_nationality_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="meta.identity.has_other_nationality === 'yes'"
        >
          <div class="field">
            <label class="label">{{ $t("if you answered yes specify") }}</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.identity.other_nationality_specify"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-multiline mb-4">
        <div class="column is-6">
          <div class="field">
            <label class="label"
              >{{ $t("department according to dpi") }}:</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.acting_type.department_dpi"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label"
              >{{ $t("municipality according to dpi") }}:</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.acting_type.municipality_dpi"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("gender") }}:</label>
            <div class="control">
              <label class="radio mr-3">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_gender_male"
                  name="gender"
                  value="M"
                  v-model="meta.acting_type.gender"
                  disabled
                />
                <label for="chk_gender_male">
                  {{ $t("male") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_gender_female"
                  name="gender"
                  value="F"
                  v-model="meta.acting_type.gender"
                  disabled
                />
                <label for="chk_gender_female">
                  {{ $t("female") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("marital status") }}:</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_marital_status_single"
                  name="marital_status"
                  value="S"
                  v-model="meta.acting_type.marital_status"
                  disabled
                />
                <label for="chk_marital_status_single">
                  {{ $t("single") }}
                </label>
              </label>

              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_marital_status_married"
                  name="marital_status"
                  value="C"
                  v-model="meta.acting_type.marital_status"
                  disabled
                />
                <label for="chk_marital_status_married">
                  {{ $t("married") }}
                </label>
              </label>

              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_marital_status_divorced"
                  name="marital_status"
                  value="D"
                  v-model="meta.acting_type.marital_status"
                  disabled
                />
                <label for="chk_marital_status_divorced">
                  {{ $t("divorced") }}
                </label>
              </label>

              <label class="radio ml-0 mt-1">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_marital_status_widowed"
                  name="marital_status"
                  value="V"
                  v-model="meta.acting_type.marital_status"
                  disabled
                />
                <label for="chk_marital_status_widowed">
                  {{ $t("widowed") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <generic-dropdown
              :is_inverted="false"
              :title="$t('profession occupation')"
              :placeholder="$t('select one')"
              url="/account-request/catalogs/profession/catalog"
              name_field="name"
              value_field="profession_id"
              @selected="
                (itm) =>
                  itm
                    ? (meta.acting_type.profession_occupation = itm.name)
                    : null
              "
              ref="profession_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
      </div>

      <!-- 2. Contacto y Domicilio -->
      <div class="section-header">
        <p class="has-text-weight-bold">2. {{ $t("contact and address") }}</p>
      </div>

      <div class="columns is-multiline mb-4">
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("cellphone 1") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.contact_address.cellphone_1"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("cellphone 2") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.contact_address.cellphone_2"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("landline") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.contact_address.landline"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("email") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                type="email"
                v-model="meta.contact_address.email"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("home address complete address") }}*
              {{ $t("must be exactly as is in your receipt") }}
            </label>
            <div class="control">
              <textarea
                class="textarea is-borderless"
                v-model="meta.contact_address.home_address"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("country") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.contact_address.home_country"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <generic-dropdown
              :is_inverted="false"
              :title="$t('department')"
              :placeholder="$t('select one')"
              url="/account-request/catalogs/department/catalog"
              name_field="name"
              value_field="department_id"
              @selected="home_department_selected"
              ref="home_department_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <generic-dropdown
              :is_inverted="false"
              :title="$t('municipality')"
              :placeholder="$t('select one')"
              url="/account-request/catalogs/municipality/catalog"
              name_field="name"
              ref="home_municipality_dropdown"
              value_field="municipality_id"
              :extra_data="{
                department_id: meta.contact_address.home_department_id,
              }"
              @selected="home_municipality_selected"
              :is_multiple="false"
            />
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("zone") }}:</label>
            <div class="select is-fullwidth">
              <select
                v-model="meta.contact_address.home_zone"
                class="is-borderless"
              >
                <option value="" disabled>{{ $t("select one") }}</option>
                <option :value="i - 1" v-for="i in 26">
                  {{ $t("zone") }} {{ i - 1 }}
                </option>
              </select>
            </div>
            <!-- <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.contact_address.home_zone"
              />
            </div> -->
          </div>
        </div>
      </div>

      <!-- 3. Información económica del titular -->
      <div class="section-header">
        <p class="has-text-weight-bold">
          3. {{ $t("economic information of the holder") }}
        </p>
      </div>

      <div class="columns is-multiline mb-4">
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{
                $t(
                  "economic activity of the holder according to the unified tax registry rtu"
                )
              }}*</label
            >
            <div class="control">
              <textarea
                class="textarea is-borderless"
                v-model="meta.economic_info.economic_activity_rtu"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("approximate monthly amount of income q") }}*</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                type="number"
                step="0.01"
                v-model="meta.economic_info.monthly_income_amount"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{ $t("sources of income") }}:</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_income_sources_own_business"
                  name="income_sources"
                  value="own_business"
                  v-model="meta.economic_info.income_sources"
                />
                <label for="chk_income_sources_own_business">
                  {{ $t("own business") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_income_sources_dependency_relationship"
                  name="income_sources"
                  value="dependency_relationship"
                  v-model="meta.economic_info.income_sources"
                />
                <label for="chk_income_sources_dependency_relationship">
                  {{ $t("dependency relationship") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="meta.economic_info.income_sources === 'own_business'"
        >
          <div class="field">
            <label class="label"
              >{{ $t("indicate the commercial name of the business") }}:</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.economic_info.business_commercial_name"
              />
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="meta.economic_info.income_sources === 'dependency_relationship'"
        >
          <div class="field">
            <label class="label">{{ $t("specify the employer name") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.economic_info.employer_name"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("select the income sources that correspond") }}:</label
            >
            <div class="control">
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <div class="field">
                    <input
                      class="is-checkradio"
                      type="checkbox"
                      id="chk_income_sources_professional_activities"
                      name="chk_income_sources_professional_activities"
                      value="professional_activities"
                      v-model="meta.economic_info.income_sources_selection"
                    />
                    <label for="chk_income_sources_professional_activities">
                      {{ $t("professional activities") }}
                    </label>
                  </div>
                </div>
                <div class="control">
                  <div class="field">
                    <input
                      class="is-checkradio"
                      type="checkbox"
                      id="chk_income_sources_retirement"
                      name="chk_income_sources_retirement"
                      value="retirement"
                      v-model="meta.economic_info.income_sources_selection"
                    />
                    <label for="chk_income_sources_retirement">
                      {{ $t("retirement") }}
                    </label>
                  </div>
                </div>

                <div class="control">
                  <div class="field">
                    <input
                      class="is-checkradio"
                      type="checkbox"
                      id="chk_income_sources_maintenance"
                      name="chk_income_sources_maintenance"
                      value="maintenance"
                      v-model="meta.economic_info.income_sources_selection"
                    />
                    <label for="chk_income_sources_maintenance">
                      {{ $t("maintenance") }}
                    </label>
                  </div>
                </div>

                <div class="control">
                  <div class="field">
                    <input
                      class="is-checkradio"
                      type="checkbox"
                      id="chk_income_sources_other"
                      name="chk_income_sources_other"
                      value="other_specify"
                      v-model="meta.economic_info.income_sources_selection"
                    />
                    <label for="chk_income_sources_other">
                      {{ $t("other specify") }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="
            meta.economic_info.income_sources_selection &&
            meta.economic_info.income_sources_selection.includes(
              'other_specify'
            )
          "
        >
          <div class="field">
            <label class="label"
              >{{ $t("if you selected other specify") }}:</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.economic_info.other_income_specify"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("approximate monthly amount of expenses q") }}*</label
            >
            <div class="control">
              <input
                class="input is-borderless"
                type="number"
                step="0.01"
                v-model="meta.economic_info.monthly_expenses_amount"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{ $t("seniority years") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                type="number"
                v-model="meta.economic_info.seniority_years"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 4. Perfil Transaccional -->
      <div class="section-header">
        <p class="has-text-weight-bold">4. {{ $t("transactional profile") }}</p>
      </div>
      <div class="columns is-multiline mb-4">
        <div class="column is-12">
          <div class="field">
            <label class="label">{{ $t("account purpose") }}</label>
            <div class="control">
              <div class="field is-grouped">
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_savings"
                      name="account_purpose"
                      value="savings"
                      v-model="meta.transactional_profile.account_purpose"
                    />
                    <label for="chk_transactional_profile_savings">
                      {{ $t("savings") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_payroll"
                      name="account_purpose"
                      value="payroll"
                      v-model="meta.transactional_profile.account_purpose"
                    />
                    <label for="chk_transactional_profile_payroll">
                      {{ $t("payroll") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_transfers"
                      name="account_purpose"
                      value="transfers"
                      v-model="meta.transactional_profile.account_purpose"
                    />
                    <label for="chk_transactional_profile_transfers">
                      {{ $t("transfers") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_others"
                      name="account_purpose"
                      value="others"
                      v-model="meta.transactional_profile.account_purpose"
                    />
                    <label for="chk_transactional_profile_others">
                      {{ $t("others") }}
                    </label>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="meta.account_purpose === 'others'">
          <div class="field">
            <label class="label">{{ $t("if others specify") }}</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="
                  meta.transactional_profile.account_purpose_other_specify
                "
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{ $t("main source of funds") }}*</label>
            <div class="control">
              <div class="field is-grouped">
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_funds_source_salary"
                      name="funds_source"
                      value="salary"
                      v-model="meta.transactional_profile.funds_source"
                    />
                    <label for="chk_transactional_profile_funds_source_salary">
                      {{ $t("salary") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_funds_source_fees"
                      name="funds_source"
                      value="fees"
                      v-model="meta.transactional_profile.funds_source"
                    />
                    <label for="chk_transactional_profile_funds_source_fees">
                      {{ $t("fees") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_funds_source_sales"
                      name="funds_source"
                      value="sales"
                      v-model="meta.transactional_profile.funds_source"
                    />
                    <label for="chk_transactional_profile_funds_source_sales">
                      {{ $t("sales") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_funds_source_remittances"
                      name="funds_source"
                      value="remittances"
                      v-model="meta.transactional_profile.funds_source"
                    />
                    <label
                      for="chk_transactional_profile_funds_source_remittances"
                    >
                      {{ $t("remittances") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_funds_source_investment"
                      name="funds_source"
                      value="investment"
                      v-model="meta.transactional_profile.funds_source"
                    />
                    <label
                      for="chk_transactional_profile_funds_source_investment"
                    >
                      {{ $t("investment") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_transactional_profile_funds_source_others"
                      name="funds_source"
                      value="others"
                      v-model="meta.transactional_profile.funds_source"
                    />
                    <label for="chk_transactional_profile_funds_source_others">
                      {{ $t("others") }}
                    </label>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="meta.transactional_profile.funds_source === 'others'"
        >
          <div class="field">
            <label class="label">{{ $t("if others specify") }}:</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.transactional_profile.funds_source_other_specify"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 5. Beneficiarios -->
      <div class="section-header">
        <p class="has-text-weight-bold">5. {{ $t("beneficiaries") }}</p>
      </div>
      <div class="columns is-multiline mb-4">
        <div class="column is-12">
          <div class="field">
            <div class="control">
              <div class="field is-grouped">
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_beneficiaries_yes"
                      name="has_beneficiaries"
                      value="yes"
                      v-model="meta.beneficiaries_info.has_beneficiaries"
                    />
                    <label for="chk_beneficiaries_yes">
                      {{ $t("yes") }}
                    </label>
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input
                      class="is-checkradio"
                      type="radio"
                      id="chk_beneficiaries_no"
                      name="has_beneficiaries"
                      value="no"
                      v-model="meta.beneficiaries_info.has_beneficiaries"
                    />
                    <label for="chk_beneficiaries_no">
                      {{ $t("no") }}
                    </label>
                  </label>
                </div>
              </div>
              <p class="help">
                {{
                  $t(
                    "if you answered yes complete the registers the sum of percentages must be 100 percent"
                  )
                }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="column is-12"
          v-if="meta.beneficiaries_info.has_beneficiaries === 'yes'"
        >
          <div class="table-container">
            <table class="table is-fullwidth is-bordered">
              <thead>
                <tr class="has-background-grey-light">
                  <th>{{ $t("beneficiary name") }}</th>
                  <th>{{ $t("dpi id") }}</th>
                  <th>{{ $t("relationship") }}</th>
                  <th>{{ $t("percentage") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(beneficiary, index) in meta.beneficiaries_info
                    .beneficiaries"
                  :key="index"
                >
                  <td>
                    <input
                      class="input is-borderless"
                      v-model="beneficiary.name"
                    />
                  </td>
                  <td>
                    <input
                      class="input is-borderless"
                      v-model="beneficiary.dpi_id"
                    />
                  </td>
                  <td>
                    <input
                      class="input is-borderless"
                      v-model="beneficiary.relationship"
                    />
                  </td>
                  <td>
                    <input
                      class="input is-borderless"
                      type="number"
                      min="1"
                      max="100"
                      v-model="beneficiary.percentage"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <button @click="addBeneficiary" class="button is-info">
              {{ $t("add beneficiary") }}
            </button>
          </div>
        </div>
      </div>

      <!-- 7. Declaraciones y Cumplimiento -->
      <div class="section-header">
        <p class="has-text-weight-bold">
          6. {{ $t("declarations and compliance") }}
        </p>
      </div>

      <div class="columns is-multiline mb-4">
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{
                $t(
                  "is politically exposed person pep family or close associate"
                )
              }}*</label
            >
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_pep_yes"
                  name="is_pep"
                  value="yes"
                  v-model="meta.compliance.is_pep"
                />
                <label for="chk_is_pep_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_pep_no"
                  name="is_pep"
                  value="no"
                  v-model="meta.compliance.is_pep"
                />
                <label for="chk_is_pep_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="false && meta.compliance.is_pep === 'yes'"
        >
          <div class="field">
            <label class="label">{{ $t("if you answered yes specify") }}</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.compliance.pep_specify"
                style="border-bottom: 1px solid #ccc"
              />
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t("is contractor or provider of the state cpej")
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_state_contractor_yes"
                  name="is_state_contractor"
                  value="yes"
                  v-model="meta.compliance.is_state_contractor"
                />
                <label for="chk_is_state_contractor_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_state_contractor_no"
                  name="is_state_contractor"
                  value="no"
                  v-model="meta.compliance.is_state_contractor"
                />
                <label for="chk_is_state_contractor_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 8. fatca - Preguntas FEIC (Persona Individual) -->
      <div class="section-header">
        <p class="has-text-weight-bold">
          7. {{ $t("fatca feic questions individual person") }}
        </p>
      </div>

      <div class="columns is-multiline mb-4">
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t("were you born in the united states")
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_born_in_usa_yes"
                  name="born_in_usa"
                  value="yes"
                  v-model="meta.fatca.born_in_usa"
                />
                <label for="chk_is_born_in_usa_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_born_in_usa_no"
                  name="born_in_usa"
                  value="no"
                  v-model="meta.fatca.born_in_usa"
                />
                <label for="chk_is_born_in_usa_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t("are you us citizen or holder of green card")
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_citizen_green_card_yes"
                  name="us_citizen_green_card"
                  value="yes"
                  v-model="meta.fatca.us_citizen_green_card"
                />
                <label for="chk_is_us_citizen_green_card_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_citizen_green_card_no"
                  name="us_citizen_green_card"
                  value="no"
                  v-model="meta.fatca.us_citizen_green_card"
                />
                <label for="chk_is_us_citizen_green_card_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t("are you us tax resident ee uu")
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_tax_resident_yes"
                  name="is_us_tax_resident"
                  value="yes"
                  v-model="meta.fatca.us_tax_resident"
                />
                <label for="chk_is_us_tax_resident_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_tax_resident_no"
                  name="is_us_tax_resident"
                  value="no"
                  v-model="meta.fatca.us_tax_resident"
                />
                <label for="chk_is_us_tax_resident_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t(
                "do you have residential or postal address in ee uu including po box or in care of"
              )
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_address_yes"
                  name="is_us_address"
                  value="yes"
                  v-model="meta.fatca.us_address"
                />
                <label for="chk_is_us_address_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_address_no"
                  name="is_us_address"
                  value="no"
                  v-model="meta.fatca.us_address"
                />
                <label for="chk_is_us_address_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t("do you have us phone number ee uu")
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_phone_yes"
                  name="is_us_phone"
                  value="yes"
                  v-model="meta.fatca.us_phone"
                />
                <label for="chk_is_us_phone_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_phone_no"
                  name="is_us_phone"
                  value="no"
                  v-model="meta.fatca.us_phone"
                />
                <label for="chk_is_us_phone_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">{{
              $t(
                "do you maintain permanent instructions to transfer funds to accounts in ee uu"
              )
            }}</label>
            <div class="control">
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_transfer_instructions_yes"
                  name="is_us_transfer_instructions"
                  value="yes"
                  v-model="meta.fatca.us_transfer_instructions"
                />
                <label for="chk_is_us_transfer_instructions_yes">
                  {{ $t("yes") }}
                </label>
              </label>
              <label class="radio">
                <input
                  class="is-checkradio"
                  type="radio"
                  id="chk_is_us_transfer_instructions_no"
                  name="is_us_transfer_instructions"
                  value="no"
                  v-model="meta.fatca.us_transfer_instructions"
                />
                <label for="chk_is_us_transfer_instructions_no">
                  {{ $t("no") }}
                </label>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label"
              >{{ $t("if you answered yes to any complete") }}:</label
            >
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("tin ssn") }}</label>
            <div class="control">
              <input class="input is-borderless" v-model="meta.fatca.tin_ssn" />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("document w9 w8ben") }}</label>
            <div class="control">
              <input
                class="input is-borderless"
                v-model="meta.fatca.document_w9_w8ben"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="title is-4">{{ $t("confirmation") }}</div>
      <div class="field">
        <input
          class="is-checkradio"
          type="checkbox"
          id="chk_confirm_veracity"
          name="chk_confirm_veracity"
          v-model="meta.confirm_veracity"
          required
        />
        <label for="chk_confirm_veracity">
          {{
            $t("i confirm that all information provided is true and complete")
          }}
        </label>
      </div>
      <!-- <div class="field">
        <div class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="meta.confirm_veracity" required />
            {{
              $t("i confirm that all information provided is true and complete")
            }}
          </label>
        </div>
      </div> -->
      <div class="field is-grouped is-grouped-right">
        <div class="control">
          <button
            class="button is-primary"
            :disabled="!meta.confirm_veracity"
            @click="save"
          >
            <span class="icon">
              <i class="fa fa-paper-plane"></i>
            </span>
            <span>{{ $t("submit request") }}</span>
          </button>
        </div>
      </div>
    </div>

    <p v-if="error" class="notification is-danger" v-html="error"></p>
    <sms-code-modal
      ref="sms_code_modal"
      @verification-completed="onVerificationCompleted"
    />
    <email-code-modal
      ref="email_code_modal"
      @verification-completed="onVerificationCompleted"
    />
    <dpi-modal ref="dpi_modal" @verification-completed="onDpiVerified" />
  </div>
</template>

<script>
import {
  warning_message,
  get,
  generate_error_message_text,
  post,
  format_date,
  drive_static_file_url,
} from "@/utils";
import moment from "moment";
import Page404 from "@/components/404/Index.vue";
import Page500 from "@/components/500/Index.vue";
import Page200 from "@/components/200/Index.vue";
import SmsCodeModal from "./personal-savings-complete-components/sms-code-method-modal/Index.vue";
import EmailCodeModal from "./personal-savings-complete-components/email-code-method-modal/Index.vue";
import DpiModal from "./personal-savings-complete-components/dpi-method-modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "PersonalSavingsAccountRequestComplete",
  components: {
    Page404,
    Page500,
    Page200,
    SmsCodeModal,
    EmailCodeModal,
    DpiModal,
    GenericDropdown,
  },
  data() {
    return {
      error: "",
      request: null,
      meta: {
        // 1. Datos de Identidad
        identity: {
          first_name: "",
          second_name: "",
          first_surname: "",
          second_surname: "",
          married_surname: "",
          cui: "",
          nit: "",
          birth_date: "",
          nationality: "",
          has_other_nationality: "",
          other_nationality_specify: "",
        },

        // Tipo de actuación del titular
        acting_type: {
          acts_own_behalf: "",
          department_dpi: "",
          municipality_dpi: "",
          gender: "",
          marital_status: "",
          profession_occupation: "",
        },

        // 2. Contacto y Domicilio
        contact_address: {
          cellphone_1: "",
          cellphone_2: "",
          landline: "",
          email: "",
          home_address: "",
          home_country: "",
          home_department: "",
          home_municipality: "",
          home_zone: "",
        },

        // 3. Información económica
        economic_info: {
          economic_activity_rtu: "",
          monthly_income_amount: "",
          income_sources: "",
          business_commercial_name: "",
          dependency_work: "",
          employer_name: "",
          income_sources_selection: [],
          other_income_specify: "",
          monthly_expenses_amount: "",
          seniority_years: "",
        },

        // 4. Perfil Transaccional
        transactional_profile: {
          account_purpose: "",
          account_purpose_other_specify: "",
          funds_source: "",
          funds_source_other_specify: "",
        },

        // 5. Beneficiarios
        beneficiaries_info: {
          has_beneficiaries: "",
          beneficiaries: [
            { name: "", dpi_id: "", relationship: "", percentage: "" },
            { name: "", dpi_id: "", relationship: "", percentage: "" },
            { name: "", dpi_id: "", relationship: "", percentage: "" },
          ],
        },

        // 7. Declaraciones y Cumplimiento
        compliance: {
          is_pep: "",
          pep_specify: "",
          is_state_contractor: "",
        },

        // 8. FATCA
        fatca: {
          born_in_usa: "",
          us_citizen_green_card: "",
          us_tax_resident: "",
          us_address: "",
          us_phone: "",
          us_transfer_instructions: "",
          tin_ssn: "",
          document_w9_w8ben: "",
        },
      },
      confirm_veracity: false,
      document_not_found: false,
      document_expired: false,
      document_signed: false,
    };
  },
  methods: {
    format_date,
    drive_static_file_url,
    addBeneficiary() {
      this.meta.beneficiaries_info.beneficiaries.push({
        name: "",
        dpi_id: "",
        relationship: "",
        percentage: "",
      });
    },
    load_request(uuid) {
      let v = this;
      v.$root.loader(true);
      get("/account-request/personal-savings/complete", { uuid: uuid })
        .then((response) => {
          v.request = response;
          v.load_request_data(response);

          // if (
          //   response &&
          //   response.settings &&
          //   response.settings.security_method
          // ) {
          //   v.perform_security_method(
          //     response.settings.security_method,
          //     response
          //   )
          //     .then(() => {

          //       // if (response.status === "formulary-completed") {
          //       //   if (
          //       //     response.settings.documentation &&
          //       //     response.settings.documentation.length > 0
          //       //   ) {
          //       //     v.$router.push({
          //       //       path: `/account-request/personal-savings/documentation/${this.request.uuid}`,
          //       //     });
          //       //   } else {
          //       //     console.log("Document signed");
          //       //     v.document_signed = true;
          //       //   }
          //       // } else if (
          //       //   ["in-progress", "unopened"].includes(response.status)
          //       // ) {
          //       //   v.load_request_data(response);
          //       // }
          //     })
          //     .catch((error) => {
          //       v.error = generate_error_message_text(error);
          //       console.error("Security method failed", error);
          //     });
          // } else {
          //   v.request = response;
          //   v.load_request_data(response);
          // }
        })
        .catch((error) => {
          if (error.status === 404) {
            v.document_not_found = true;
          } else if (
            error.status === 500 &&
            error.data.includes("Request has expired")
          ) {
            v.document_expired = true;
            // } else if (error.status === 400 && error.data.includes("completed")) {
            //   v.document_signed = true;
          } else if (
            error.status === 500 &&
            error.data.includes("Documentation completed")
          ) {
            v.document_signed = true;
          } else {
            console.error(error);
            v.error = generate_error_message_text(error);
            // error_message(v.error);
          }
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    save() {
      let v = this;
      v.error = "";
      if (!v.meta.confirm_veracity) {
        v.error = v.$t(
          "you must confirm that all information provided is true and complete"
        );
        return;
      }
      let payload = {
        uuid: v.$route.params.uuid,
        data: v.meta,
        blackbox: window.MODUL_BLACKBOX,
      };

      v.$root.loader(true);
      post("/account-request/personal-savings/complete/submit", payload)
        .then((response) => {
          let flow = v.request.settings.flow;
          if (flow === "capture-documentation-verification") {
            this.$router.push({
              path: `/account-request/personal-savings/documentation/${this.request.uuid}`,
            });
          } else if (flow === "capture-verification-documentation") {
            this.$router.push({
              path: `/account-request/personal-savings/verification/${this.request.uuid}`,
            });
          } else {
            console.error("Unknown flow", flow);
          }
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        })
        .finally(() => {
          this.$root.loader(false);
        });

      // console.log(payload);
    },
    load_request_data(response) {
      let v = this;

      if (response.status === "formulary-completed") {
        if (
          response.settings.documentation &&
          response.settings.documentation.length > 0
        ) {
          v.$router.push({
            path: `/account-request/personal-savings/documentation/${this.request.uuid}`,
          });
        } else {
          console.log("Document signed");
          v.request = null;
          v.document_signed = true;
        }
      } else if (["in-progress", "unopened"].includes(response.status)) {
        if (
          response &&
          response.destinatary &&
          response.destinatary.renap_data
        ) {
          let obj = {};
          // Datos de identidad
          if (response.destinatary.renap_data.PRIMER_NOMBRE)
            obj.identity = {
              ...obj.identity,
              first_name: response.destinatary.renap_data.PRIMER_NOMBRE,
            };
          if (response.destinatary.renap_data.SEGUNDO_NOMBRE)
            obj.identity = {
              ...obj.identity,
              second_name: response.destinatary.renap_data.SEGUNDO_NOMBRE,
            };
          if (response.destinatary.renap_data.PRIMER_APELLIDO)
            obj.identity = {
              ...obj.identity,
              first_surname: response.destinatary.renap_data.PRIMER_APELLIDO,
            };
          if (response.destinatary.renap_data.SEGUNDO_APELLIDO)
            obj.identity = {
              ...obj.identity,
              second_surname: response.destinatary.renap_data.SEGUNDO_APELLIDO,
            };
          if (response.destinatary.renap_data.APELLIDO_CASADA)
            obj.identity = {
              ...obj.identity,
              married_surname: response.destinatary.renap_data.APELLIDO_CASADA,
            };
          if (response.destinatary.renap_data.CUI)
            obj.identity = {
              ...obj.identity,
              cui: response.destinatary.renap_data.CUI,
            };
          if (response.destinatary.renap_data.FECHA_NACIMIENTO)
            obj.identity = {
              ...obj.identity,
              birth_date: moment(
                response.destinatary.renap_data.FECHA_NACIMIENTO,
                "DD/MM/YYYY"
              ).format("YYYY-MM-DD"),
            };
          if (response.destinatary.renap_data.NACIONALIDAD)
            obj.identity = {
              ...obj.identity,
              nationality: response.destinatary.renap_data.NACIONALIDAD,
            };

          // Datos de actuación
          if (response.destinatary.renap_data.GENERO)
            obj.acting_type = {
              ...obj.acting_type,
              gender: response.destinatary.renap_data.GENERO,
            };
          if (response.destinatary.renap_data.ESTADO_CIVIL)
            obj.acting_type = {
              ...obj.acting_type,
              marital_status: response.destinatary.renap_data.ESTADO_CIVIL,
            };
          if (response.destinatary.renap_data.OCUPACION)
            obj.acting_type = {
              ...obj.acting_type,
              profession_occupation: response.destinatary.renap_data.OCUPACION,
            };
          if (response.destinatary.renap_data.DEPTO_NACIMIENTO)
            obj.acting_type = {
              ...obj.acting_type,
              department_dpi: response.destinatary.renap_data.DEPTO_NACIMIENTO,
            };
          if (response.destinatary.renap_data.MUNI_NACIMIENTO)
            obj.acting_type = {
              ...obj.acting_type,
              municipality_dpi: response.destinatary.renap_data.MUNI_NACIMIENTO,
            };

          // Datos de contacto
          if (response.destinatary.phone)
            obj.contact_address = {
              ...obj.contact_address,
              cellphone_1: response.destinatary.phone,
            };
          if (response.destinatary.email)
            obj.contact_address = {
              ...obj.contact_address,
              email: response.destinatary.email,
            };
          v.meta = { ...v.meta, ...obj };

          // Set Guatemala for everyone
          v.meta.contact_address.home_country = "GUATEMALA";
          v.meta.acting_type.acts_own_behalf = "yes";

          setTimeout(() => {
            window
              .jQuery(".generic-dropdown .label")
              .addClass("has-text-black");
          }, 500);
        }
      }
    },
    perform_security_method(method, account_request) {
      let v = this;
      return new Promise((resolve, reject) => {
        if (method === "none") {
          console.log("No security method to perform");
          resolve();
        } else if (method === "email-code") {
          v.$refs.email_code_modal.show(account_request);
        } else if (method === "sms-code") {
          v.$refs.sms_code_modal.show(account_request);
        } else if (method === "whatsapp-code") {
          console.log("Performing WhatsApp code verification");
          reject("WhatsApp code verification is not implemented yet.");
        } else if (method === "dpi") {
          v.$refs.dpi_modal.show(account_request);
        } else {
          console.error("Unknown security method:", method);
          reject(`Unknown security method: ${method}`);
        }
      });
    },
    onVerificationCompleted(account_request) {
      console.log("Verification completed", account_request);
      this.request = account_request;
      this.load_request_data(account_request);
    },
    onDpiVerified(account_request) {
      console.log("DPI verification completed", account_request);
      this.request = account_request;
      this.load_request_data(account_request);
    },
    home_department_selected(department) {
      let v = this;
      if (department) {
        v.meta.contact_address.home_department = department.name;
        v.meta.contact_address.home_department_id = department.department_id;

        v.meta.contact_address.home_municipality = "";
        v.meta.contact_address.home_municipality_id = "";
        v.$refs.home_municipality_dropdown.clear();
      }
    },
    home_municipality_selected(municipality) {
      let v = this;
      if (municipality) {
        v.meta.contact_address.home_municipality = municipality.name;
        v.meta.contact_address.home_municipality_id =
          municipality.municipality_id;
      }
    },
    tax_department_selected(department) {
      let v = this;
      if (department) {
        v.meta.contact_address.tax_department = department.name;
        v.meta.contact_address.tax_department_id = department.department_id;

        v.meta.contact_address.tax_municipality = "";
        v.meta.contact_address.tax_municipality_id = "";
        v.$refs.tax_municipality_dropdown.clear();
      }
    },
    tax_municipality_selected(municipality) {
      let v = this;
      if (municipality) {
        v.meta.contact_address.tax_municipality = municipality.name;
        v.meta.contact_address.tax_municipality_id =
          municipality.municipality_id;
      }
    },
  },
  mounted() {
    let uuid = this.$route.params.uuid;
    if (uuid) this.load_request(uuid);
    else error = this.$t("invalid request id");
  },
  created() {
    // Load scripts /truvalidate/config.js and /truvalidate/loader_only.js
    let script1 = document.createElement("script");
    script1.src = "/truvalidate/config.js";
    script1.async = true;
    document.head.appendChild(script1);
    let script2 = document.createElement("script");
    script2.src = "/truvalidate/loader_only.js";
    script2.async = true;
    document.head.appendChild(script2);
  },
};
</script>

<style scoped>
.field .label,
.title,
.subtitle {
  font-weight: bold;
  color: #161616 !important;
}
/* Estilos personalizados para inputs sin borde */
.input.is-borderless {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  background: transparent;
  color: #121212;
}

select.is-borderless {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  background: transparent;
  color: #121212;
}

.input.is-borderless:disabled {
  background: #f5f5f5;
  color: #999 !important;
  cursor: not-allowed;
}

.input.is-borderless:focus {
  border-bottom: 2px solid #007bff;
  box-shadow: none;
}

.input.is-borderless::placeholder {
  color: #121212;
  font-style: italic;
}

.textarea.is-borderless {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  background: transparent;
  resize: vertical;
  color: #121212;
}

.textarea.is-borderless:focus {
  border-bottom: 2px solid #007bff;
  box-shadow: none;
}

/* Ajustar el tamaño de las etiquetas */
.label.is-small {
  font-size: 12px;
  /* color: #333; */
  font-weight: normal;
  margin-bottom: 5px;
}

/* Estilo mejorado para secciones */
.section-header {
  background-color: #c0c0c0;
  color: #000;
  padding: 8px 15px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 15px;
  margin-bottom: 15px;
  text-align: center;
}

.section-header h6 {
  margin: 0 !important;
}

/* Logo mejorado */
.multi-money-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  font-size: 24px;
  font-weight: bold;
  color: #000;
}

.logo-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #000;
}

/* Mejorar el espaciado de campos */
.field {
  margin-bottom: 1rem;
}

.columns {
  margin-bottom: 0 !important;
}

.column {
  padding: 0.75rem 0.5rem;
}

/* Estilo para tablas */
.table {
  background-color: #f5f5f5;
}

.table.is-bordered td,
.table.is-bordered th {
  border: 1px solid #ddd;
}

.table.is-bordered td input {
  border: none;
  box-shadow: none;
  background: transparent;
}

/* Estilo para checkboxes y radios */
.radio,
.checkbox {
  margin-right: 0.5rem;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .column {
    padding: 0.5rem 0.25rem !important;
  }

  .radio,
  .checkbox {
    display: block;
    margin-bottom: 0.5rem;
  }

  .field.is-grouped {
    flex-direction: column;
  }

  .field.is-grouped .control {
    margin-left: 0 !important;
    margin-bottom: 0.5rem;
  }
}

/* Estilo para campos de uso interno */
.internal-use-field input,
.internal-use-field textarea {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.internal-use-field input:focus,
.internal-use-field textarea:focus {
  border-bottom: 2px solid #007bff;
  box-shadow: none;
}
</style>
